import { useCallback } from 'react';
import { withRouter } from 'react-router-dom';
import { wireAuthConsumer } from 'automation-ui-core/context/AuthContext';
import * as SpecialActionIds from 'automation-ui-flow-core/canvas/SpecialActionIds';
import FlowCanvasBase from 'automation-ui-canvas/containers/FlowCanvasBase';
import FlowCanvasNode from 'automation-ui-canvas/components/canvas/FlowCanvasNode';
import ReenrollmentView from 'automation-ui-canvas/components/enrollment/ReenrollmentView';
import { getIsObjectlessFlow } from 'automation-ui-flow-core/flow/flowUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const WiredFlowCanvasBase = withRouter(wireAuthConsumer(FlowCanvasBase));
export default function CreateFlowPreviewCanvas({
  areLangStringsLoading,
  flow,
  scrollElementRef
}) {
  const isObjectlessWorkflow = getIsObjectlessFlow(flow.toHybridFlowInterface());
  const handleRenderCanvasNode = useCallback(({
    id,
    width,
    height
  }) => {
    let isSelected = false;
    let overrideTitleAction = () => null;
    if (id === SpecialActionIds.ENROLLMENT) {
      isSelected = true;
      overrideTitleAction = () => /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx("div", {}), !isObjectlessWorkflow && /*#__PURE__*/_jsx("span", {
          children: /*#__PURE__*/_jsx(ReenrollmentView, {
            flow: flow.toHybridFlowInterface()
          })
        })]
      });
    }
    return /*#__PURE__*/_jsx(FlowCanvasNode, {
      id: id,
      width: width,
      height: height,
      isSelected: isSelected,
      flow: flow,
      getActionOutputsForTargetActionById: () => [],
      zoomLevel: 1,
      overrideTitleAction: overrideTitleAction,
      readOnly: true
    });
  }, [flow, isObjectlessWorkflow]);
  if (areLangStringsLoading) {
    return null;
  }
  return /*#__PURE__*/_jsx(WiredFlowCanvasBase, {
    flow: flow,
    mode: "fullCanvas",
    areLangStringsLoading: areLangStringsLoading,
    flowId: NaN,
    onRenderCanvasNode: handleRenderCanvasNode,
    canvasScrollElementRef: scrollElementRef,
    disableMinimap: true
  });
}